import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, MaskedLines } from './motion';

export const CTASection = ({ title = ['Have a project', 'on your mind?'], text = 'Tell us about your vision — our team will respond with a clear path from concept to completion.' }) => (
  <section data-testid="cta-section" className="bg-accent relative overflow-hidden">
    <div className="absolute -right-20 -top-20 w-72 h-72 border border-ink/15 rotate-45 pointer-events-none" aria-hidden="true" />
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-24 lg:py-36">
      <MaskedLines
        lines={title}
        inView
        lineClassName="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold uppercase tracking-tight leading-[0.95] text-ink"
      />
      <Reveal delay={0.25} className="mt-8 max-w-xl">
        <p className="text-ink/70 text-base lg:text-lg leading-relaxed">{text}</p>
      </Reveal>
      <Reveal delay={0.35} className="mt-10">
        <Link
          to="/contact"
          data-testid="cta-start-project"
          className="inline-flex items-center gap-3 bg-ink text-white font-display font-medium uppercase tracking-wide px-8 py-4 text-sm transition-colors duration-300 hover:bg-black"
        >
          Start a Project <ArrowUpRight size={18} />
        </Link>
      </Reveal>
    </div>
  </section>
);
